import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikcabservice() {



  const cardData = {
"keyword": "Pune to Nashik Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Nashik Cab Service for travelers looking for safe, affordable, and convenient intercity transportation. Whether you are planning a religious visit, business trip, vineyard tour, family outing, or weekend getaway, our taxi service ensures a smooth and stress-free journey. With experienced drivers, well-maintained air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Nashik. Our fleet includes sedans, SUVs, and premium cars suitable for solo travelers, families, and corporate clients. With flexible one-way and round-trip options, doorstep pickup, and 24/7 customer support, Shivai Travels makes your Pune to Nashik journey easy and comfortable.",

"topPlaces": [
  {
    "title": "Trimbakeshwar Temple",
    "description":
      "Trimbakeshwar Temple is one of the twelve Jyotirlingas dedicated to Lord Shiva and a major pilgrimage site near Nashik. Travelers using Pune to Nashik cab service often visit this sacred temple for spiritual blessings and religious significance."
  },
  {
    "title": "Sula Vineyards",
    "description":
      "Sula Vineyards is one of India’s most famous wineries offering wine tasting, vineyard tours, and scenic views. A cab from Pune to Nashik makes it easy to enjoy a relaxing and luxurious experience here."
  },
  {
    "title": "Panchavati",
    "description":
      "Panchavati is a historic and religious area in Nashik associated with the Ramayana. Pune to Nashik cab travelers often explore its temples and sacred sites for cultural and spiritual experiences."
  },
  {
    "title": "Sita Gufa",
    "description":
      "Sita Gufa is a mythological cave temple believed to be associated with Lord Rama, Sita, and Lakshmana. It is a popular stop for pilgrims traveling from Pune to Nashik."
  },
  {
    "title": "Kalaram Temple",
    "description":
      "Kalaram Temple is an ancient and revered temple dedicated to Lord Rama, known for its black stone idol and historical importance. Cab services from Pune make it easy to visit this spiritual landmark."
  },
  {
    "title": "Anjneri Hill",
    "description":
      "Anjneri Hill is believed to be the birthplace of Lord Hanuman and is popular for trekking and natural beauty. Travelers from Pune enjoy a scenic cab journey to this peaceful destination near Nashik."
  },
  {
    "title": "Pandav Leni Caves",
    "description":
      "Pandav Leni Caves are ancient rock-cut caves showcasing Buddhist heritage and architecture. Pune to Nashik cab service offers convenient access for history and culture enthusiasts."
  },
  {
    "title": "Nashik Riverfront (Godavari Ghats)",
    "description":
      "The Godavari Ghats in Nashik are sacred riverfront steps known for religious rituals and evening aarti. Travelers often visit this peaceful location during their Pune to Nashik journey."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description":
      "Saptashrungi Devi Temple is a famous hill temple dedicated to Goddess Durga located near Nashik. Cab service from Pune provides a comfortable travel option for devotees visiting this holy site."
  },
  {
    "title": "Coin Museum Nashik",
    "description":
      "Coin Museum is a unique attraction showcasing the history of Indian currency and numismatics. Pune to Nashik cab service makes it easy for travelers to explore this educational destination."
  }
],



services: [
  {
    name: "Pune to Nashik Cab",
    description: "Pune to Nashik cab service provides reliable transportation between Pune and Nashik with comfortable vehicles and experienced drivers. Vehicles are suitable for highway travel ensuring smooth and safe journeys for families, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nashik. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Nashik Taxi",
    description: "Pune to Nashik taxi service offers dependable transportation for passengers traveling between Pune and Nashik with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for business trips, tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Nashik. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Nashik",
    description: "Cab from Pune to Nashik service provides comfortable intercity transportation for passengers traveling for business, religious tours, airport transfers, and family visits. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Nashik. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Nashik",
    description: "Taxi from Pune to Nashik service offers reliable transportation with comfortable vehicles and professional drivers for long-distance travel between Pune and Nashik. Vehicles provide smooth highway travel suitable for tourism, business meetings, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Nashik. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Nashik Cab Service",
    description: "Pune to Nashik cab service provides dependable transportation solutions for passengers traveling between Pune and Nashik with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for highway travel ensuring safe and smooth journeys for individuals, families, and corporate travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nashik. Ideal for religious travel, tourism, and business trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Nashik Taxi Fare",
    description: "Pune to Nashik taxi fare service provides transparent pricing information for passengers planning intercity travel between Pune and Nashik. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nashik. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Nashik One Way Cab",
    description: "Pune to Nashik one way cab service provides economical transportation for passengers traveling from Pune to Nashik without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for business trips, religious tours, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Nashik including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Nashik Round Trip Taxi",
    description: "Pune to Nashik round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Nashik. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nashik. Ideal for business travel, tourism, temple visits, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Nashik Cab Booking",
    description: "Pune to Nashik cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Nashik. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nashik. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Nashik Cab",
    description: "Cheap Pune to Nashik cab service provides affordable transportation between Pune and Nashik with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for tourism, business travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Nashik. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Nashik Taxi",
    description: "Best Pune to Nashik taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for business travel, tourism, and religious trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Nashik. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Nashik Cab",
    description: "Sedan Pune to Nashik cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Nashik. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for intercity journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Nashik. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Nashik Taxi",
    description: "SUV Pune to Nashik taxi service provides spacious transportation for families and groups traveling between Pune and Nashik. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for long-distance journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Nashik. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Nashik Cab",
    description: "Innova Pune to Nashik cab service provides premium SUV transportation for passengers seeking comfortable and reliable intercity travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for business travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Nashik. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Pune to Nashik Innova Crysta Cab",
    description: "Pune to Nashik Innova Crysta cab service provides luxury SUV transportation with premium comfort for passengers traveling between Pune and Nashik. Innova Crysta vehicles offer spacious interiors, smooth highway performance, and comfortable seating suitable for long-distance journeys. Professional chauffeurs ensure safe driving and punctual pickup services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Nashik. Flexible booking options allow convenient Innova Crysta cab reservations."
  },
  {
    name: "Luxury Innova Cab Pune Nashik",
    description: "Luxury Innova cab Pune Nashik service offers premium intercity transportation with high-end Innova vehicles and professional chauffeurs. Vehicles provide spacious seating, luggage capacity, and smooth ride quality suitable for corporate travel, tourism, and family journeys. Professional drivers ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Nashik. Flexible booking options allow convenient luxury Innova cab reservations."
  }
],

tableData: [
  ["Pune to Nashik Cab", "Pune to Nashik Taxi"],
  ["Cab from Pune to Nashik", "Taxi from Pune to Nashik"],
  ["Pune to Nashik Cab Service", "Pune to Nashik Taxi Fare"],
  ["Pune to Nashik One Way Cab", "Pune to Nashik Round Trip Taxi"],
  ["Pune to Nashik Cab Booking", "Cheap Pune to Nashik Cab"],
  ["Best Pune to Nashik Taxi", "Sedan Pune to Nashik Cab"],
  ["SUV Pune to Nashik Taxi", "Innova Pune to Nashik Cab"],
  ["Pune to Nashik Innova Crysta Cab", "Luxury Innova Cab Pune Nashik"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Nashik Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Nashik cab service with professional drivers, comfortable vehicles, and timely pickup for smooth intercity travel between Pune and Nashik."
      },
      {
        WhyChooseheading: "Affordable Pune to Nashik Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Nashik cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Nashik Cab Service Availability",
        WhyChoosedescription: "Our Pune to Nashik cab service operates 24 hours a day for business travel, family trips, religious tours, airport transfers, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Nashik taxi service, round-trip bookings, Nashik Darshan tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, corporate travelers, and groups."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Highway Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Nashik highway routes and ensure safe driving, smooth travel, and punctual arrival for every journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Nashik cab service?", answer: "Pune to Nashik cab service provides comfortable taxi transportation between Pune and Nashik for business travel, religious tours, and family trips." },
    { question: "Is Pune to Nashik cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Nashik cab service." },
    { question: "Which vehicles are available for Pune to Nashik travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Nashik?", answer: "Yes, customers can book one-way as well as round-trip Pune to Nashik taxi services." },
    { question: "Do you provide Nashik Darshan cab service?", answer: "Yes, Shivai Travels provides Nashik Darshan and Trimbakeshwar travel cab services." },
    { question: "Are all Pune to Nashik taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Nashik cab service online?", answer: "Yes, customers can easily book Pune to Nashik cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family trips and group tours." },
    { question: "Are Pune to Nashik cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Nashik cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive seasons." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Jadhav",
    feedback:
      "Shivai Travels provided a comfortable Pune to Nashik cab service with a smooth highway ride, clean car, and an experienced driver ensuring a safe journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Kulkarni",
    feedback:
      "The Pune to Nashik taxi service was very reliable with on-time pickup and a hassle-free travel experience, making the long journey very comfortable.",
    rating: 5
  }
];








































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nashik Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-nashik-cab.jpg",
  "description": "Book Pune to Nashik cab service for safe and comfortable outstation travel. Shivai Travels offers affordable one-way and round-trip taxi service with sedan, SUV, Innova, and Innova Crysta luxury cabs available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-nashik-cab-service"
  }
};

  return (
    <div>


<Helmet>
  <title>Pune to Nashik Cab Service | Affordable Outstation Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Nashik cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and Innova Crysta luxury cabs available 24x7 for safe outstation journeys."
  />

  <meta
    name="keywords"
    content="Pune to nashik cab, pune to nashik taxi, cab from pune to nashik, taxi from pune to nashik, pune to nashik cab service, pune to nashik taxi fare, pune to nashik one way cab, pune to nashik round trip taxi, pune to nashik cab booking, cheap pune to nashik cab, best pune to nashik taxi, sedan pune to nashik cab, suv pune to nashik taxi, innova pune to nashik cab, pune to nashik innova crysta cab, Pune to Nashik Cabs, Pune to Nashik Cab Service, Pune to Nashik Taxi Service, Pune to Nashik Cab Booking, Best Pune to Nashik Cab, Cheap Pune to Nashik Taxi, 24x7 Pune to Nashik Cab Service, One Way Pune to Nashik Cab, Round Trip Pune to Nashik Taxi, Outstation Cab Pune to Nashik, Pune to Nashik Innova Crysta Cab, Innova Crysta Cab Pune to Nashik, Pune to Nashik Crysta Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/15.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonashikcabservice;